module.exports = __webpack_public_path__ + "static/img/newsImg.3142ced.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newsImg.png
// module id = rMxC
// module chunks = 1